<template>
  <b-row>
    <b-col
      cols="12"
      md="12"
      lg="12"
    >
      <div>
        <!-- toggle button -->
        <b-button
          v-ripple.400="'rgba(113, 102, 240, 0.15)'"
          v-b-toggle.collapse-1
          variant="outline-primary"
        >
          <feather-icon
            icon="PlusIcon"
            size="18"
          />
          Agregar otra profesión
        </b-button>
        <b-collapse
          id="collapse-1"
          class="mt-2"
        >
          <b-card
            no-body
            class="border m-1 p-3"
          >
            <validation-observer ref="simpleRules">
              <b-form
                class="w-100"
              >
                <b-row>
                  <b-col md="4">
                    <!-- add grado profesion -->
                    <validation-provider
                      #default="{ errors }"
                      name="grado"
                      rules="required"
                    >
                      <label for="grado">Último grado de estudios *</label>
                      <b-form-group>
                        <v-select
                          v-model="fmNewProfesion.id_grado"
                          :options="gradoOptions"
                          :reduce="grado => grado.id"
                          label="nombre"
                          filterable
                        />
                      </b-form-group>
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-col>
                  <b-col md="8">
                    <b-form-group
                      label="Carrera"
                      label-for="carrera"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="carrera"
                        rules="min:6|max:255"
                      >
                        <b-form-input
                          v-model="fmNewProfesion.carrera"
                          :state="errors.length > 0 ? false:null"
                          autocomplete="off"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col md="6">
                    <b-form-group
                      label="Cédula"
                      label-for="cedula"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="cedula"
                        rules="alpha_num|min:7|max:8"
                      >
                        <b-form-input
                          id="cedula"
                          v-model="fmNewProfesion.cedula"
                          :state="errors.length ? false : null"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                  <b-col md="6">
                    <b-form-group
                      label="Institución educativa donde se obtuvo título/cédula"
                      label-for="institucion_educativa"
                    >
                      <validation-provider
                        #default="{ errors }"
                        name="Institucion Educativa"
                        rules="min:3"
                      >
                        <b-form-input
                          id="institucion_educativa"
                          v-model="fmNewProfesion.institucion_educativa"
                          :state="errors.length ? false : null"
                        />
                        <small class="text-danger">{{ errors[0] }}</small>
                      </validation-provider>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col md="4">
                    <label for="ef-titulacion">Entidad Federativa de titulación</label>
                    <validation-provider
                      #default="{ errors }"
                      name="ef-titulacion"
                    >
                      <b-form-group>
                        <v-select
                          id="ef-titulacion"
                          v-model="fmNewProfesion.ef_titulacion"
                          placeholder="Seleccione entidad federativa"
                          label="nombre"
                          :reduce="(ef) => ef.id"
                          :options="estadoOptions"
                          :clearable="false"
                        />
                      </b-form-group>
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>
                  </b-col>
                  <b-col md="4">
                    <label for="cct">CCT - Clave de Centro de Trabajo</label>
                    <validation-provider
                      #default="{ errors }"
                      name="cct"
                      rules="alpha_num|max:20"
                    >
                      <b-form-input
                        id="cct"
                        v-model="fmNewProfesion.cct"
                        :state="errors.length ? false : null"
                      />
                      <small class="text-danger">{{ errors[0] }}</small>
                    </validation-provider>

                  </b-col>
                  <b-col md="4">
                    <label for="fecha-ultima-asignatura">Fecha de expedición de la cédula</label>
                    <cleave
                      id="fecha-ultima-asignatura"
                      v-model="fmNewProfesion.fecha_para_autoridad_educativa"
                      :options="{ date: true, delimiter: '-', datePattern: ['Y', 'm', 'd'] }"
                      :raw="false"
                      class="form-control"
                      placeholder="YYYY-MM-DD"
                    />
                  </b-col>
                </b-row>
                <b-row>
                  <b-col md="6">
                    <label for="cargo">Cargo *</label>
                    <validation-observer ref="datosCargo">
                      <cargoform
                        ref="datosCargoForm"
                      />
                    </validation-observer>
                  </b-col>
                  <b-col md="6">
                    <label for="Cargo">Área de adscripción *</label>
                    <validation-observer ref="datosDep">
                      <depform
                        ref="datosDepForm"
                      />
                    </validation-observer>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col md="12">
                    <label for="cedula">Dependencia *</label>
                    <validation-observer ref="datosDependencia">
                      <dependenciaform
                        :resetea.sync="reseteadeps"
                        @reseteaemit="reseteadeps=$event"
                        @tipodegobierno="idtg=$event"
                        @idestado="idef=$event"
                        @idmunicipio="idmuni=$event"
                        @iddependencia="iddp=$event"
                      />
                    </validation-observer>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col md="4">
                    <b-button
                      variant="outline-primary"
                      size="sm"
                      class="m-2"
                      @click.prevent="validationForm()"
                    >
                      <feather-icon
                        icon="SaveIcon"
                        size="20"
                        class="align-middle text-primary"
                      /> Guardar
                    </b-button>
                  </b-col>
                </b-row>
              </b-form>
            </validation-observer>
            <b-alert
              variant="primary"
              show
            >
              <div class="alert-body">
                <span>El campo de <b>"Dependencia"</b> es un <b>catálogo pre-cargado</b> de nuestra base de datos, si no encuentras lo que buscas, ponte en contacto con soporte técnico.</span>
              </div>
            </b-alert>
          </b-card>
        </b-collapse>
      </div>
    </b-col>
    <b-col
      cols="12"
    >
      <editar-usuario-profesion-one
        :is-edit-user-profesion-sidebar-active.sync="isEditUserProfesionSidebarActive"
        :profesion-data.sync="profesionOne"
        :index-profesion="indexProfesion"
        :id-p="idp"
        :grados="gradoOptions"
        :departamentos="departamentoOptions"
        :puestos="puestoOptions"
        :estados="estadoOptions"
        @resetdatos="profesionOne=$event"
      />
      <!-- <editar-usuario-dependencias
        :is-edit-user-dependencia-sidebar-active.sync="isEditUserDependenciaSidebarActive"
        :dependencia-data="dependenciaData"
        :profesiones="profesiones"
      /> -->
      <!-- Profesión -->
      <b-card
        no-bod
        class="border mt-1"
      >
        <b-card-header class="p-1">
          <b-card-title class="font-medium-2">
            <feather-icon
              icon="BookOpenIcon"
              size="18"
            />
            <span class="align-middle ml-50">HISTORIAL PROFESIÓN</span>
          </b-card-title>
        </b-card-header>
        <b-table
          ref="historialProfesionTabla"
          striped
          responsive
          :items="userData.profesion"
          class="mb-0"
          :fields="tableColumns"
        >
          <template #cell(carrera)="data">
            <div v-if="validarDependencia(data)">
              <p>{{ data.item.acronimo }} {{ data.item.carrera }}</p>
              <p> Cedula: {{ data.item.cedula }}</p>
              <p v-if="estadoOptions.length !== 0 && data.item.ef_titulacion">
                EF de titulación: {{ estadoOptions.find(edo => edo.id === data.item.ef_titulacion).nombre }}
              </p>
              <p> CCT: {{ data.item.cct }}</p>
              <p>Expedición de cédula: {{ data.item.fecha_para_autoridad_educativa }}
              </p>
              <p>Institución educativa donde se obtuvo título/cédula: {{ data.item.institucion_educativa }}</p>
            </div>
          </template>
          <template #cell(puesto)="data">
            <p v-if="validarDependencia(data)">
              {{ data.item.puesto }}
            </p>
            <p v-if="validarDependencia(data)">
              {{ data.item.departamento }}
            </p>
          </template>
          <template #cell(dependencia)="data">
            <div v-if="data.item.tipo_gobierno">

              <small>{{ data.item.tipo_gobierno.nombre }}</small>
              <div v-if="data.item.tipo_gobierno.id !== 3">
                <p v-if="data.item.entidad_federativa">
                  Estado: {{ data.item.entidad_federativa.nombre }}
                </p>
                <p>Ente: {{ data.item.dependencias.nombre }}</p>
              </div>
              <div v-if="data.item.tipo_gobierno.id === 3">
                <p v-if="data.item.municipio">
                  Estado: {{ data.item.entidad_federativa.nombre }}
                </p>
                <p v-if="data.item.municipio">Municipio: {{ data.item.municipio.nombre }}
                </p>
              </div>

            </div>
          </template>
          <template #cell(opciones)="data">
            <div v-if="validarDependencia(data)">
              <b-button
                variant="border-transparent"
                class="mb-1 mb-sm-0 mr-0 mr-sm-1"
                size="sm"
                @click.prevent="editarProfesion
                  ({
                    profesion: data.item,
                    index:data.index,
                  })"
              >
                <feather-icon
                  :id="`profesion-row-${data.index}-editar`"
                  icon="Edit3Icon"
                  class="text-primary"
                />Editar profesión
              </b-button>
              <b-tooltip
                title="Editar profesión"
                :target="`profesion-row-${data.index}-editar`"
                placement="lefttop"
              /><br>
              <b-button
                v-if="validarProfesion(data)"
                variant="border-transparent"
                class="mb-1 mb-sm-0 mr-0 mr-sm-1"
                size="sm"
                @click="eliminarProfesion(
                  data.item.id_profesion,
                  data.item.id_dependencia,
                  data.index
                )"
              >
                <feather-icon
                  :id="`profesion-row-${data.index}-eliminar`"
                  icon="TrashIcon"
                  class="text-danger"
                />Eliminar
              </b-button>
              <b-tooltip
                title="Eliminar profesión"
                :target="`profesion-row-${data.index}-eliminar`"
                placement="lefttop"
              />
            </div>
          </template>

        </b-table>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import {
  BRow, BCol, BTable, BCard, BCardHeader, BCardTitle, BButton,
  BForm, BFormGroup, BCollapse, VBToggle, BTooltip, BFormInput, BAlert,
} from 'bootstrap-vue'
import { onMounted } from '@vue/composition-api'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import { useUsuariosCatalogos } from '@/views/campus/usuarios/useUsuarios'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { useToast } from 'vue-toastification/composition'
import Cleave from 'vue-cleave-component'
import dependenciaform from '@/views/components/dependencias/dependencia.vue'
import EditarUsuarioProfesionOne from './EditarUsuarioProfesionOne.vue'
import cargoform from './components/cargo.vue'
import depform from './components/departamento.vue'

export default {
  components: {
    BRow,
    BCol,
    BButton,
    BTable,
    BCard,
    BCardHeader,
    BCardTitle,
    BForm,
    BFormGroup,
    EditarUsuarioProfesionOne,
    ValidationProvider,
    ValidationObserver,
    BCollapse,
    BTooltip,
    vSelect,
    BFormInput,
    BAlert,
    cargoform,
    dependenciaform,
    Cleave,
    depform,
  },

  directives: {
    'b-toggle': VBToggle,
    Ripple,
  },
  props: {
    userData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      profesionOne: {},
      indexProfesion: 0,
      idp: 0,
      dependenciaData: {},
      idtg: null,
      idef: null,
      idmuni: null,
      iddp: null,
      reseteadeps: null,
      depseleccionada: false,

      profesiones: [],
      // FROM
      fmNewProfesion: { type: Object },
      fmdeliminar: { type: Object },
      postDataForm: { type: Object },
      cargoDatos: { type: Object },
      deptoDatos: { type: Object },
      cargoId: null,
      departamentoId: null,
      nombreCargo: String,
      nombreDepartamento: String,
      // EXTRA
      loader: {
        formulario: false,
      },
    }
  },
  setup() {
    const toast = useToast()
    const isEditUserProfesionSidebarActive = false
    const isEditUserDependenciaSidebarActive = false
    const {
      gradoOptions, puestoOptions, estadoOptions,
      gradoOptionsPromise, puestoOptionsPromise,
      departamentoOptions, departamentoPromise, estadoPromise,
    } = useUsuariosCatalogos()
    const tableColumns = [
      { key: 'carrera', sortable: false },
      { key: 'puesto', sortable: false, label: 'cargo' },
      { key: 'dependencia', sortable: false },
      { key: 'opciones' },
    ]
    const fetchCatalogos = () => {
      // loader.value.filters = true
      Promise.all([gradoOptionsPromise, puestoOptionsPromise, departamentoPromise, estadoPromise])
        .then(() => {
        })
        .catch(error => {
          toast({
            component: ToastificationContent,
            props: {
              title: 'Error en petición [Catalogos]',
              text: `${error} Descuida, puedes seguir trabajando con la tabla de resultados, nosotros verémos la manera de solucionar el inconveniente ;)`,
              icon: 'AlertCircleIcon',
              variant: 'danger',
            },
          },
          { timeout: 10000 })
        })
    }
    onMounted(() => {
      fetchCatalogos() //* Load options (selects)
    })
    return {
      gradoOptions,
      puestoOptions,
      estadoOptions,
      departamentoOptions,
      isEditUserProfesionSidebarActive,
      isEditUserDependenciaSidebarActive,
      tableColumns,
    }
  },
  watch: {
    idmuni(value) {
      if (value !== null) {
        if (value.id !== null && this.idtg.id === 3) this.depseleccionada = true
        else this.depseleccionada = false
      }
    },
    iddp(value) {
      if (value !== null) {
        if (value.id !== null && (this.idtg.id === 2 || this.idtg.id === 1)) this.depseleccionada = true
        else this.depseleccionada = false
      }
    },
    idtg() {
      this.depseleccionada = false
    },
  },
  methods: {
    editarProfesion(datos) {
      this.profesionOne = datos.profesion
      this.indexProfesion = datos.index
      this.idp = this.userData.fk
      this.isEditUserProfesionSidebarActive = true
    },
    validationForm() {
      this.reseteadeps = false
      this.$refs.simpleRules.validate().then(success => {
        if (success && this.depseleccionada === true) {
          this.cargoId = null
          this.departamentoId = null
          this.agregarACatalogos()
        } else {
          this.$bvToast.toast('Selecciona todos los campos obligatorios', {
            title: 'Cuidado',
            variant: 'danger',
            solid: true,
          },
          { timeout: 10000 })
        }
      })
    },
    agregarACatalogos() {
      const agregarCargo = new Promise((resolve, reject) => {
        this.$refs.datosCargo.validate().then(success => {
          if (success) {
            this.fmNewProfesion.cargo = this.$refs.datosCargoForm.cargo
            if (this.fmNewProfesion.cargo.alterno === null) {
              this.nombreCargo = this.fmNewProfesion.cargo.selected.nombre
              this.cargoId = this.fmNewProfesion.cargo.selected.id
              resolve()
            } else {
              this.nombreCargo = this.fmNewProfesion.cargo.alterno
              this.loader.formulario = true
              this.cargoDatos.nombre = this.fmNewProfesion.cargo.alterno
              this.$store.dispatch('usuario/postwsperfil', { data: this.cargoDatos, accion: 10 })
                .then(response => {
                  this.loader.formulario = false
                  this.puestoOptions.push({ id: response.data, mostrar: 1, nombre: this.cargoDatos.nombre })
                  this.cargoId = response.data
                  resolve(response.data)
                }, error => {
                  this.loader.formulario = false
                  this.$bvToast.toast(error, {
                    title: 'Cuidado agregar cargo',
                    variant: 'danger',
                    solid: true,
                  },
                  { timeout: 10000 })
                  reject(new Error(error))
                })
            }
          } else {
            reject(new Error('Falta cargar el cargo'))
          }
        })
      })
      const agregarDepartamento = new Promise((resolve, reject) => {
        this.$refs.datosDep.validate().then(success => {
          if (success) {
            this.fmNewProfesion.departamento = this.$refs.datosDepForm.dep
            if (this.fmNewProfesion.departamento.alterno === null) {
              this.nombreDepartamento = this.fmNewProfesion.departamento.selected.nombre
              this.departamentoId = this.fmNewProfesion.departamento.selected.id
              resolve()
            } else {
              this.nombreDepartamento = this.fmNewProfesion.departamento.alterno
              this.loader.formulario = true
              this.deptoDatos.nombre = this.fmNewProfesion.departamento.alterno
              this.$store.dispatch('usuario/postwsperfil', { data: this.deptoDatos, accion: 12 })
                .then(response => {
                  this.loader.formulario = false
                  resolve()
                  this.departamentoOptions.push({ id: response.data, nombre: this.deptoDatos.nombre })
                  this.departamentoId = response.data
                }, error => {
                  this.loader.formulario = false
                  this.$bvToast.toast(error, {
                    title: 'Cuidado agregar área de adscripcion',
                    variant: 'danger',
                    solid: true,
                  },
                  { timeout: 10000 })
                  reject(new Error(error))
                })
              resolve()
            }
          } else {
            reject(new Error('Falta cargar el departamento'))
          }
        })
      })
      Promise.all([agregarCargo, agregarDepartamento]).then(() => {
        this.submitprofesion()
      // eslint-disable-next-line no-unused-vars
      }).catch(error => {
        this.loader.formulario = false
        this.$bvToast.toast('Revisa el cargo y área de adscripcion', {
          title: 'Cuidado all',
          variant: 'danger',
          solid: true,
        },
        { timeout: 10000 })
      })
    },
    validarDependencia(datos) {
      let respuesta = true
      if (datos.index !== 0) if (this.userData.profesion[datos.index - 1].id_profesion === datos.item.id_profesion) respuesta = false
      return respuesta
    },
    validarProfesion(datos) {
      let respuesta = true
      if (datos.index < this.userData.profesion.length - 1) { if (this.userData.profesion[datos.index + 1].id_profesion === datos.item.id_profesion) respuesta = false }
      return respuesta
    },

    submitprofesion() {
      if (this.departamentoId !== null && this.cargoId !== null) {
        this.loader.formulario = true
        this.fmNewProfesion.id_puesto = this.cargoId
        this.fmNewProfesion.id_departamento = this.departamentoId
        this.fmNewProfesion.id_persona = this.userData.fk
        this.$store.dispatch('usuario/postwsperfil', { data: this.fmNewProfesion, accion: 2 })
          .then(response => {
            this.loader.formulario = false
            this.submitDependencia(response.data[0].id)
          }, error => {
            this.loader.formulario = false
            this.$bvToast.toast(error, {
              title: 'Cuidado en guardar registo',
              variant: 'danger',
              solid: true,
            },
            { timeout: 10000 })
          })
      } else {
        this.$bvToast.toast('Revisa el cargo y área de adscripcion', {
          title: 'Cuidado',
          variant: 'danger',
          solid: true,
        },
        { timeout: 10000 })
      }
    },
    agregatabla(idprof, idproddep) {
      const g = this.gradoOptions.find(grado => grado.id === this.fmNewProfesion.id_grado)
      this.userData.profesion.push(
        {
          id_profesion: idprof,
          id_prof_dep: idproddep,
          carrera: this.fmNewProfesion.carrera,
          puesto: this.nombreCargo,
          id_puesto: this.cargoId,
          grado: g.nombre,
          id_grado: g.id,
          acronimo: g.acronimo,
          nivelAcademico: g.nivel_academico,
          departamento: this.nombreDepartamento,
          id_departamento: this.departamentoId,
          cedula: this.fmNewProfesion.cedula,
          institucion_educativa: this.fmNewProfesion.institucion_educativa,
          ef_titulacion: this.fmNewProfesion.ef_titulacion,
          cct: this.fmNewProfesion.cct,
          fecha_para_autoridad_educativa: this.fmNewProfesion.fecha_para_autoridad_educativa,
          dependencia: this.iddp ? this.iddp.nombre : null,
          id_dependencia: this.iddp ? this.iddp.id : null,

          dependencias: this.iddp,
          tipo_gobierno: this.idtg,
          municipio: this.idmuni,
          entidad_federativa: this.idef,
        },
      )
    },
    submitDependencia(id) {
      this.loader.formulario = true
      this.postDataForm.municipio = this.idmuni
      this.postDataForm.tipo_gob = this.idtg
      this.postDataForm.dependencia = this.iddp
      this.postDataForm.profesion = id

      this.$store.dispatch('usuario/postwsperfil', { data: this.postDataForm, accion: 6 })
        .then(response => {
          this.loader.formulario = false
          this.agregatabla(id, response.data)
          this.registroExitoso()
        }, error => {
          this.loader.formulario = false
          this.$bvToast.toast(error, {
            title: 'Cuidado',
            variant: 'danger',
            solid: true,
          },
          { timeout: 10000 })
        })
    },
    eliminarProfesion(profesion, dependencia, index) {
      this.loader.formulario = true
      this.fmdeliminar = {}
      this.fmdeliminar.profesion = profesion
      this.fmdeliminar.dependencia = dependencia
      this.fmdeliminar.persona_fk = this.userData.fk
      this.$store.dispatch('usuario/postwsperfil', { data: this.fmdeliminar, accion: 8 })
        // eslint-disable-next-line no-unused-vars
        .then(response => {
          this.userData.profesion.splice(index, 1)
          this.registroExitoso()
        }, error => {
          this.loader.formulario = false
          this.$bvToast.toast(error, {
            title: 'Cuidado',
            variant: 'danger',
            solid: true,
          },
          { timeout: 10000 })
        })
    },
    registroExitoso() {
      this.$swal({
        title: '<b>Operación exitosa</b>',
        html: '',
        icon: 'success',
        timer: 10000,
        showConfirmButton: false,
        buttonsStyling: false,
      })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
